<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          <CCol sm="12" lg="12" >  
            <div class="content-wrapper">                            
              <div id="app">              
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas' height='500' :allowExcelExport='true'  :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='toolbar' :pageSettings='pageSettings' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings='selectionSettings' :rowSelected='rowSelected' 
                    :toolbarClick="toolbarClick"  >                             
                    <e-columns>                                
                        <e-column field='no' headerText='廠商編號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>              
                        <e-column field='name' headerText='廠商名稱' width='250'></e-column>   
                        <e-column field='short_name' headerText='簡稱' width='120'></e-column>   
                        <e-column field='type' headerText='進貨分類' width='120'></e-column>                         
                        <e-column field='tax_id_number' headerText='統一編號' width='140' ></e-column>   
                        <e-column field='tel_no' headerText='電話號碼' width='140'></e-column>   
                        <e-column field='tel_no_1' headerText='電話號碼' width='140'></e-column>   
                        <e-column field='mobile_no' headerText='手機號碼' width='140'></e-column>
                        <e-column field='contact' headerText='連絡人' width='140'></e-column> 
                        <e-column field='fax_no' headerText='傳真號碼' width='140'></e-column> 
                        <e-column field='liability' headerText='負責人' width='140'></e-column> 
                        <e-column field='address' headerText='公司地址' width='360' ></e-column> 
                        <e-column field='memo' headerText='備註' width='360' ></e-column> 
                        <e-column field='ldate' headerText='最後採購日' width='200' ></e-column>     
                        <!-- <e-column field='my_evaluation' headerText='自己評鑑分數' width='160' ></e-column> 
                        <e-column field='avg_evaluation' headerText='平均評鑑分數' width='160' ></e-column> 
                        <e-column field='my_last_evaluation' headerText='去年評鑑分數' width='160' ></e-column>                        
                        <e-column field='avg_last_evaluation' headerText='去年平均評鑑分數' width='160' ></e-column>  -->
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
        </CRow>      

        <div class="control-section">
          <ejs-dialog ref="modalFractionDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_fraction_header' :buttons='dialogFractionButtons' 
              width='700px'>
            <div class="form-group col-md-12">
              <div class="alert alert-primary" role="alert">
                原物料：品質由採購、品保中心共同評分，交期、配合度、服務態度由採購評分。<br/>
                代工：品質由製令、品保中心共同評分，交期、配合度、服務態度由製令、商管組共同評分。<br/>
                運輸：品質、交期、配合度、服務態度由商管組評分。                    
              </div>
            </div>
            <div class="col-lg-12 control-section slider-default">                  
              <div class='content_wrapper'>          
                <div>                   
                   <div class='sliderwrap default'>
                      <label class='labeltext'>品質25%-</label><b style="color: blue;">給分:{{ e_quality }}分</b>   
                      <ejs-slider id="apislider" ref="slider" :value="e_quality" :min="min" :max="max" :type="type"  :ticks="ticks"
                        :step="step" :showButtons="shwbuttons" :orientation="orientation" :enabled="isenable" :readonly="readonly" :change="onQualityChange"></ejs-slider>
                    </div> 
                   <div class='sliderwrap default'>
                        <label class='labeltext'>交期25%-</label><b style="color: blue;">給分:{{ e_delivery_date }}分</b>  
                        <ejs-slider id="apislider" ref="slider" :value="e_delivery_date" :min="min" :max="max" :type="type" :ticks="ticks"
                          :step="step" :showButtons="shwbuttons" :orientation="orientation" :enabled="isenable" :readonly="readonly" :change="onDeliveryDateChange"></ejs-slider>
                    </div>
                    <div class='sliderwrap default'>
                        <label class='labeltext'>配合度25%-</label><b style="color: blue;">給分:{{ e_fit }}分</b>  
                        <ejs-slider id="apislider" ref="slider" :value="e_fit" :min="min" :max="max" :type="type" :ticks="ticks"
                          :step="step" :showButtons="shwbuttons" :orientation="orientation" :enabled="isenable" :readonly="readonly" :change="onFitChange"></ejs-slider>
                    </div>
                    <div class='sliderwrap default'>
                        <label class='labeltext'>服務態度25%-</label><b style="color: blue;">給分:{{ e_service }}分</b>
                        <ejs-slider id="apislider" ref="slider" :value="e_service" :min="min" :max="max" :type="type" :ticks="ticks"
                          :step="step" :showButtons="shwbuttons" :orientation="orientation" :enabled="isenable" :readonly="readonly" :change="onServiceChange"></ejs-slider>  
                    </div>
                    </div>
                </div> 
            </div>
          </ejs-dialog> 
        </div>

        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>    
      </CCardBody>   
    </CCard>
  </template>
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
import Vue from "vue";
import { SliderComponent } from "@syncfusion/ej2-vue-inputs";
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Sort, Toolbar, Edit, Filter, ExcelExport } from "@syncfusion/ej2-vue-grids";
import { ColumnSeries, DataLabel, LineSeries, SplineSeries, SplineAreaSeries, Legend, Tooltip, DateTime, Category, Highlight, ChartAnnotation, StripLine } from "@syncfusion/ej2-vue-charts";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';

import zhtwLocalization  from '../language/language.json';
  
L10n.load(zhtwLocalization);
Vue.use(TooltipPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DialogPlugin);
enableRipple(true);

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-toast': ToastComponent,
    'ejs-slider': SliderComponent
  },
  provide : {
    grid: [Page, Sort, Toolbar, Edit, Filter, ExcelExport],
        chart: [ColumnSeries, SplineAreaSeries, LineSeries, SplineSeries, Legend, Tooltip, Category,DateTime, DataLabel, Highlight, ChartAnnotation, StripLine],
  },
  name: 'acceptance_scm',
  data: function() {
    return {
      limit : localStorage.getItem('scm'), 
        datas : [],
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
        pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },     
        toolbar: [             
          { text: '供應商評鑑', tooltipText: '供應商評鑑', prefixIcon: 'e-btn-icon e-description e-icons e-icon-left', id: 'Score', disabled :  localStorage.getItem('scm').indexOf('22') < 0 }, 
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   
        selectionSettings: { persistSelection: true },
        filterSettings: { type: 'CheckBox' }, 
        visible : false,
        e_selectData : null, e_selectRow: null,
        e_pwd: '', e_pwd2: '', e_header: '', e_fraction_header: '',
        e_quality: 12, e_delivery_date: 1, e_fit: 2, e_service: 3,        
        position: { X: 'Right', Y: "Bottom" },
        min: 0,
        max: 25,
        shwbuttons: true,
        step: 1,
        checked: false,
        isenable: true,
        readonly: false,
        orientation: "Horizontal", 
        ticks: { placement: 'After', largeStep: 25 },
        type: 'MinRange',
        dialogFractionButtons: [{
            click: this.dialogFractionOkClick,
            buttonModel: { content: '確認', isPrimary: true } 
          }, { 
            click: function() { this.hide(); }, 
            buttonModel: { content: '取消', isPrimary: false}
        }],
          
        dialog_buttons: [{
            click: this.dialogEditPwdOkClick,
            buttonModel: { content: '確認更改密碼', isPrimary: true } 
          }, { 
            click: function() { this.hide(); }, 
            buttonModel: { content: '取消', isPrimary: false}
        }],
      };
  },
  methods: {    
    onload:function() {
      // 初始化
    },
    submit:function() {
      this.$emit('onGetMaterialsClose');
    },
    beforeRender: function (args) {
        if (args.target.closest("td")) {
            this.$refs.tooltip.content = args.target.innerText;                
        }
    },
    onQualityChange: function(args) {
      this.e_quality = args.value;
    },
    onDeliveryDateChange: function(args) {
      this.e_delivery_date = args.value;
    },
    onFitChange: function(args) {
      this.e_fit = args.value;
    },
    onServiceChange: function(args) {
      this.e_service = args.value;
    },

    pubDoubleClick: function () {  
       
    },
    editOkClick: function () {           
      this.upData();         
    },
    valueChange: function () {  
      this.isDataChanged = true;
      this.stTime = null;
    },
    load: function() {   

    },       
    addAction: function() {

    },     
    
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    }, 
    dialogFractionOkClick: function() {
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCM/Evaluation`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            id:     this.e_selectData.no,
            quality : this.e_quality,
            delivery_date : this.e_delivery_date,
            fit:    this.e_fit,
            service: this.e_service
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.getCustomer();
        this.$refs.modalFractionDialog.hide();
        this.showMsg('建立評分完成');
      })
      .catch((error) => { 
        this.showError(error) }
      )       
    },
    toolbarClick: function(args) {
      if (args.item.id == "Export") {
        this.$refs.grid.excelExport({ fileName:'供應商.xlsx' });
      }
      if (args.item.id == "Add") { 
        return this.$router.push('/system/editmessage')     
      }    
      if (args.item.id == "Stop") {
        if ( this.e_selectRow == null) {
          this.$refs.toastRef.show( { title: '警告!', content: '請先選擇一筆廠商資料' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });   
          return;
        }
        this.setCustomer();
        return;
      }
    
      if (args.item.id == "Edit") {
        if ( this.e_selectRow == null) {
          this.$refs.toastRef.show( { title: '警告!', content: '請先選擇一筆廠商資料' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });   
          return;
        }
        this.$refs.grid.excelExport();
      }
    
      if (args.item.id == "Score") {
        if ( this.e_selectRow == null) {
          this.$refs.toastRef.show( { title: '警告!', content: '請先選擇一筆廠商資料' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });   
          return;
        }
        this.e_fraction_header = `供應商:${this.e_selectData.name}評鑑`
        this.$refs.modalFractionDialog.show();
      }
    },   

    actionComplete: function() {                             
    },
    rowSelected: function(args) {        
      this.e_selectRow = args.row.getAttribute('aria-rowindex');  
      this.e_selectData = args.data; 
      // console.log(args.data);
      this.e_quality        = args.data.quality == null ? 15 : args.data.quality ;
      this.e_delivery_date  = args.data.delivery_date == null ? 15 : args.data.delivery_date ;
      this.e_fit            = args.data.fit == null ? 15 : args.data.fit ;
      this.e_service        = args.data.service == null ? 15 : args.data.service ;
    },    
    getCustomer: function() {    
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCM/Customer/Evaluation`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.datas = response.data.datas;
        this.e_selectData = null;
        this.e_selectRow = null;
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       
    
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showError: function (error) {     
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
  },

  created() {
    this.getCustomer();
  },

  mounted() {
   
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
   
  }  
}
</script>

